import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ArrowRight } from 'lucide-react';
const results = ['Vender focaccias desde tu casa', 'Generar ingresos desde la primera semana', 'Tener un sistema simple que podés repetir'];
export function PromiseSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-charcoal relative overflow-hidden" data-id="element-194">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(212,168,83,0.05)_0%,transparent_50%)]" data-id="element-195" />

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-196">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="space-y-8" data-id="element-197">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold" data-id="element-198">
            Esto es lo que podés lograr <span className="inline-block" data-id="element-199">👇</span>
          </h2>

          <ul className="flex flex-col items-center gap-4 text-left max-w-md mx-auto" data-id="element-200">
            {results.map((item, i) => <li key={i} className="flex items-center gap-3 text-lg text-cream w-full" data-id="element-201">
                <CheckCircle2 className="w-6 h-6 text-gold flex-shrink-0" data-id="element-202" />
                <span className="font-medium" data-id="element-203">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}